import { render } from "./ItemsTree.vue?vue&type=template&id=73d3bac8&ts=true"
import script from "./ItemsTree.vue?vue&type=script&lang=ts"
export * from "./ItemsTree.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src917955987/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__